module.exports = __webpack_public_path__ + "static/img/RAPZ2_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPZ2_1.png
// module id = IbUv
// module chunks = 0